/**
 * Single source of truth for published business contact details.
 * Update here and every surface (footer, contact page, legal pages,
 * structured data) stays in sync.
 */
export const BUSINESS = {
  name: "Glow Long Golf",
  email: "hello@glowlonggolf.com",
  /** Display format */
  phone: "(707) 681-5919",
  /** E.164 for tel: links and structured data */
  phoneHref: "+17076815919",
  address: {
    line1: "4225 Solano Ave",
    line2: "PMB 733",
    city: "Napa",
    region: "CA",
    postalCode: "94558",
    country: "US",
  },
} as const;

export const ADDRESS_LINES: string[] = [
  BUSINESS.address.line1,
  BUSINESS.address.line2,
  `${BUSINESS.address.city}, ${BUSINESS.address.region} ${BUSINESS.address.postalCode}`,
];

export const ADDRESS_ONE_LINE = ADDRESS_LINES.join(", ");

export const ORGANIZATION_JSON_LD = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: BUSINESS.name,
  url: "https://glowlonggolf.com",
  email: BUSINESS.email,
  telephone: BUSINESS.phoneHref,
  address: {
    "@type": "PostalAddress",
    streetAddress: `${BUSINESS.address.line1}, ${BUSINESS.address.line2}`,
    addressLocality: BUSINESS.address.city,
    addressRegion: BUSINESS.address.region,
    postalCode: BUSINESS.address.postalCode,
    addressCountry: BUSINESS.address.country,
  },
  contactPoint: [
    {
      "@type": "ContactPoint",
      contactType: "customer service",
      telephone: BUSINESS.phoneHref,
      email: BUSINESS.email,
      areaServed: "US",
      availableLanguage: "English",
    },
  ],
};
